import { IonButton, IonLabel, IonSpinner } from '@ionic/react';
import classNames from 'classnames';

type IonButtonProps = React.ComponentPropsWithoutRef<typeof IonButton>;
type LoadingButtonProps = IonButtonProps & {
    children: React.ReactNode;
    loading?: boolean;
    disabled?: boolean;
};

const LoadingButton: React.FC<LoadingButtonProps> = ({
    children,
    disabled = false,
    loading = false,
    ...rest
}) => {
    return (
        <IonButton disabled={loading || disabled} expand="block" {...rest}>
            <IonLabel
                className={classNames({
                    'ion-hide': loading,
                })}
            >
                {children}
            </IonLabel>
            <IonSpinner
                className={classNames({
                    'ion-hide': !loading,
                })}
                name="circular"
            ></IonSpinner>
        </IonButton>
    );
};

export default LoadingButton;
